import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { PaymentMethodActions } from './payment-method.actions';
import { PaymentMethod } from '../../models/payment-method.model';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { AlertService } from '../alert/alert.service';
import { PaymentMethodService } from '../../services/payment-method.service';

export class PaymentMethodStateModel {
  public paymentMethods: PaymentMethod[];
  public error: string;
}

const defaults = {
  paymentMethods: [],
  error: '',
};

@State<PaymentMethodStateModel>({
  name: 'paymentMethod',
  defaults
})
@Injectable()
export class PaymentMethodState {

  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private paymentMethodService: PaymentMethodService
  ) { }

  @Action(PaymentMethodActions.GetPaymentMethods)
  getPaymentMethods(ctx: StateContext<PaymentMethodStateModel>, {  }: PaymentMethodActions.GetPaymentMethods) {
    return this.paymentMethodService.getPaymentMethods().subscribe({
      next: (paymentMethods: PaymentMethod[]) => {
        ctx.dispatch(new PaymentMethodActions.GetPaymentMethodsSuccess(paymentMethods));
      },
      error: (error) => {
        ctx.dispatch(new PaymentMethodActions.GetPaymentMethodsFail(error));
      }
    });
  }

  @Action(PaymentMethodActions.GetPaymentMethodsSuccess)
    getPaymentMethodsSuccess(ctx: StateContext<PaymentMethodStateModel>,
      { paymentMethods }: PaymentMethodActions.GetPaymentMethodsSuccess
    ) {
      ctx.patchState({
        paymentMethods: paymentMethods
      });
    }

    @Action(PaymentMethodActions.GetPaymentMethodsFail)
    getPaymentMethodsFailed(
      ctx: StateContext<PaymentMethodStateModel>,
      { error }: PaymentMethodActions.GetPaymentMethodsFail
    ) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('payment-methods.title');
    }
}
